import { create } from "zustand"
import { persist } from "zustand/middleware"

export interface CartItem {
  scriptId: string
  title: string
  thumbnailUrl: string | null
  priceCents: number
  tier: "play" | "download"
  creatorId: string
  creatorUsername: string
}

interface CartStore {
  items: CartItem[]
  addItem: (item: CartItem) => void
  removeItem: (scriptId: string) => void
  clearCart: () => void
  hasItem: (scriptId: string) => boolean
  itemTier: (scriptId: string) => "play" | "download" | null
}

export const useCartStore = create<CartStore>()(
  persist(
    (set, get) => ({
      items: [],

      addItem: (item) =>
        set((s) => {
          // Replace if already in cart (e.g. tier upgrade)
          const filtered = s.items.filter((i) => i.scriptId !== item.scriptId)
          return { items: [...filtered, item] }
        }),

      removeItem: (scriptId) =>
        set((s) => ({ items: s.items.filter((i) => i.scriptId !== scriptId) })),

      clearCart: () => set({ items: [] }),

      hasItem: (scriptId) => get().items.some((i) => i.scriptId === scriptId),

      itemTier: (scriptId) => get().items.find((i) => i.scriptId === scriptId)?.tier ?? null,
    }),
    { name: "goonru-cart" }
  )
)
